import { IPagedResponse } from '../apiInterfaces';
import { SalesCallActionKeys as keys } from './salesCallActionKeys';
import * as types from './salesCallActionTypes';
import { IInfoCallRequest, ISalesCall } from './salesCallInterfaces';

export const salesCallActionCreators = {
  addInfoSalesCall: (payload: IInfoCallRequest): types.AddInfoSalesCall => ({ payload, type: keys.ADD_INFO_SALESCALL }),
  addSalesCall: (salesCall: ISalesCall): types.AddSalesCall => ({ payload: salesCall, type: keys.ADD_SALESCALL }),
  addSalesCallRejected: (): types.AddSalesCallRejected => ({
    error: true,
    payload: '',
    type: keys.ADD_SALESCALL_REJECTED
  }),
  deleteSalesCall: (salesCallId: number): types.DeleteSalesCall => ({
    payload: salesCallId,
    type: keys.DELETE_SALESCALL
  }),
  deleteSalesCallFulfilled: (salesCallId: number): types.DeleteSalesCallFulfilled => ({
    payload: salesCallId,
    type: keys.DELETE_SALESCALL_FULFILLED
  }),
  deleteSalesCallRejected: (salesCallId: number): types.DeleteSalesCallRejected => ({
    error: true,
    payload: salesCallId,
    type: keys.DELETE_SALESCALL_REJECTED
  }),
  fetchPagedSalesCalls: (skip: number, reset: boolean = false): types.FetchPagedSalesCalls => ({
    payload: { skip, reset },
    type: keys.FETCH_PAGED_SALES_CALLS
  }),
  fetchSalesCalls: (businessEntityId: number, skip: number = 0): types.FetchSalesCalls => ({
    payload: { businessEntityId, skip },
    type: keys.FETCH_SALESCALLS
  }),
  fetchSalesCallsByDate: (date: Date | string, salesDistricts: string[]): types.FetchSalesCallsByDate => ({
    payload: { date, salesDistricts },
    type: keys.FETCH_SALESCALLS_BY_DATE
  }),
  fetchSalesCallsByDateFulfilled: (
    date: Date | string,
    salesCalls: ISalesCall[]
  ): types.FetchSalesCallsByDateFulfilled => ({
    payload: { date, salesCalls },
    type: keys.FETCH_SALESCALLS_BY_DATE_FULFILLED
  }),
  fetchSalesCallsByDateRejected: (date: Date | string): types.FetchSalesCallsByDateRejected => ({
    error: true,
    payload: { date },
    type: keys.FETCH_SALESCALLS_BY_DATE_REJECTED
  }),
  fetchSalesCallsRejected: (): types.FetchSalesCallsRejected => ({
    error: true,
    payload: '',
    type: keys.FETCH_SALESCALLS_REJECTED
  }),
  processSalesCalls: (salesCalls: ISalesCall[]): types.ProcessSalesCalls => ({
    payload: salesCalls,
    type: keys.PROCESS_SALESCALLS
  }),
  resetSalesCallIds: (): types.ResetSalesCallIds => ({ type: keys.RESET_SALESCALL_IDS }),
  setPaged: (payload: IPagedResponse<ISalesCall>): types.SetPagedSalesCalls => ({
    payload,
    type: keys.SET_PAGED_SALES_CALLS
  }),
  toggleLoadingPaged: (): types.ToggleLoadingPaged => ({ type: keys.TOGGLE_LOADING_PAGED }),
  updateSalesCall: (salesCall: ISalesCall): types.UpdateSalesCall => ({
    payload: salesCall,
    type: keys.UPDATE_SALESCALL
  }),
  updateSalesCallRejected: (): types.UpdateSalesCallRejected => ({
    error: true,
    payload: '',
    type: keys.UPDATE_SALESCALL_REJECTED
  })
};
